// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_owner.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { AppOwnersSearch } from "./app_owner";
import type { SearchAppOwnersResponse } from "./app_owner";
import type { SearchAppOwnersRequest } from "./app_owner";
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { AppOwners } from "./app_owner";
import type { DeleteAppOwnersResponse } from "./app_owner";
import type { DeleteAppOwnersRequest } from "./app_owner";
import type { RemoveAppOwnerResponse } from "./app_owner";
import type { RemoveAppOwnerRequest } from "./app_owner";
import type { AddAppOwnerResponse } from "./app_owner";
import type { AddAppOwnerRequest } from "./app_owner";
import type { SetAppOwnersResponse } from "./app_owner";
import type { SetAppOwnersRequest } from "./app_owner";
import type { ListAppOwnerIDsResponse } from "./app_owner";
import type { ListAppOwnerIDsRequest } from "./app_owner";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { ListAppOwnersResponse } from "./app_owner";
import type { ListAppOwnersRequest } from "./app_owner";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.app.v1.AppOwners
 */
export interface IAppOwnersClient {
    /**
     * List owners of an app.
     *
     * @generated from protobuf rpc: List
     */
    list(input: ListAppOwnersRequest, options?: RpcOptions): UnaryCall<ListAppOwnersRequest, ListAppOwnersResponse>;
    /**
     * ListOwnerIDs lists owner IDs for a given app.
     *
     * @generated from protobuf rpc: ListOwnerIDs
     */
    listOwnerIDs(input: ListAppOwnerIDsRequest, options?: RpcOptions): UnaryCall<ListAppOwnerIDsRequest, ListAppOwnerIDsResponse>;
    /**
     * Sets the owners for a given app to the specified list of users.
     *
     * @generated from protobuf rpc: Set
     */
    set(input: SetAppOwnersRequest, options?: RpcOptions): UnaryCall<SetAppOwnersRequest, SetAppOwnersResponse>;
    /**
     * Adds an owner to an app.
     *
     * @generated from protobuf rpc: Add
     */
    add(input: AddAppOwnerRequest, options?: RpcOptions): UnaryCall<AddAppOwnerRequest, AddAppOwnerResponse>;
    /**
     * Removes an owner from an app.
     *
     * @generated from protobuf rpc: Remove
     */
    remove(input: RemoveAppOwnerRequest, options?: RpcOptions): UnaryCall<RemoveAppOwnerRequest, RemoveAppOwnerResponse>;
    /**
     * Delete deletes the owners from a given app.
     *
     * @generated from protobuf rpc: Delete
     */
    delete(input: DeleteAppOwnersRequest, options?: RpcOptions): UnaryCall<DeleteAppOwnersRequest, DeleteAppOwnersResponse>;
}
/**
 * @generated from protobuf service c1.api.app.v1.AppOwners
 */
export class AppOwnersClient implements IAppOwnersClient, ServiceInfo {
    typeName = AppOwners.typeName;
    methods = AppOwners.methods;
    options = AppOwners.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * List owners of an app.
     *
     * @generated from protobuf rpc: List
     */
    list(input: ListAppOwnersRequest, options?: RpcOptions): UnaryCall<ListAppOwnersRequest, ListAppOwnersResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListAppOwnersRequest, ListAppOwnersResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * ListOwnerIDs lists owner IDs for a given app.
     *
     * @generated from protobuf rpc: ListOwnerIDs
     */
    listOwnerIDs(input: ListAppOwnerIDsRequest, options?: RpcOptions): UnaryCall<ListAppOwnerIDsRequest, ListAppOwnerIDsResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListAppOwnerIDsRequest, ListAppOwnerIDsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Sets the owners for a given app to the specified list of users.
     *
     * @generated from protobuf rpc: Set
     */
    set(input: SetAppOwnersRequest, options?: RpcOptions): UnaryCall<SetAppOwnersRequest, SetAppOwnersResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<SetAppOwnersRequest, SetAppOwnersResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Adds an owner to an app.
     *
     * @generated from protobuf rpc: Add
     */
    add(input: AddAppOwnerRequest, options?: RpcOptions): UnaryCall<AddAppOwnerRequest, AddAppOwnerResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<AddAppOwnerRequest, AddAppOwnerResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Removes an owner from an app.
     *
     * @generated from protobuf rpc: Remove
     */
    remove(input: RemoveAppOwnerRequest, options?: RpcOptions): UnaryCall<RemoveAppOwnerRequest, RemoveAppOwnerResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<RemoveAppOwnerRequest, RemoveAppOwnerResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Delete deletes the owners from a given app.
     *
     * @generated from protobuf rpc: Delete
     */
    delete(input: DeleteAppOwnersRequest, options?: RpcOptions): UnaryCall<DeleteAppOwnersRequest, DeleteAppOwnersResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteAppOwnersRequest, DeleteAppOwnersResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.app.v1.AppOwnersSearch
 */
export interface IAppOwnersSearchClient {
    /**
     * @generated from protobuf rpc: Search
     */
    search(input: SearchAppOwnersRequest, options?: RpcOptions): UnaryCall<SearchAppOwnersRequest, SearchAppOwnersResponse>;
}
/**
 * @generated from protobuf service c1.api.app.v1.AppOwnersSearch
 */
export class AppOwnersSearchClient implements IAppOwnersSearchClient, ServiceInfo {
    typeName = AppOwnersSearch.typeName;
    methods = AppOwnersSearch.methods;
    options = AppOwnersSearch.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Search
     */
    search(input: SearchAppOwnersRequest, options?: RpcOptions): UnaryCall<SearchAppOwnersRequest, SearchAppOwnersResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppOwnersRequest, SearchAppOwnersResponse>("unary", this._transport, method, opt, input);
    }
}
